var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tiktok",
    fill: "#2d6e58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,0 C397.39,0 512,114.61 512,256 C512,397.39 397.39,512 256,512 C114.61,512 0,397.39 0,256 C0,114.61 114.61,0 256,0 Z M313.5,106.01 C313.51,110.59 314.86,176.84 384.37,180.97 C384.37,200.07 384.39,213.92 384.39,232.15 C379.13,232.45 338.63,229.51 313.42,207.03 L313.34,306.67 C314.3,375.83 263.41,417.91 196.88,403.37 C82.17,369.06 120.29,198.93 235.47,217.13 C235.47,272.06 235.5,217.12 235.5,272.06 C187.92,265.06 172,304.64 184.65,332.99 C196.15,358.79 243.53,364.38 260.06,327.98 C261.93,320.86 262.86,312.73 262.86,303.61 L262.86,105.76 L313.5,106.01 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.15d0b1a993597aca44b6c8c7224fe5c8.svg";
export { ForwardRef as ReactComponent };